import { Parameter } from "../parameter/parameter";

export class Trainee {
  traineeKey?: number;
  sessionKey?: number;
  userKey: number;
  traineeFirstName: string;
  traineeLastName: string;
  traineePostalCode: string;
  traineeCity: string;
  traineeBirthDate: string;
  traineeLicence?: string;
  licences?: any[];
  sexKey: number;
  checked?: boolean;
  sessionTraineeKey?: number;
  emergencyPhoneNumber: string;
  parameters?: Parameter[];
  parameterValues?: Parameter[];
  hasParamsToSet?: boolean;
  licenceValues: any[];

  constructor(userKey: number, traineeFirstName: string, traineeLastName: string, traineePostalCode: string, traineeCity: string, traineeBirthDate: string, sexKey: number, emergencyPhoneNumber: string, licenceValues?: any[], parameterValues?: Parameter[]) {
    this.userKey = userKey;
    this.traineeFirstName = traineeFirstName;
    this.traineeLastName = traineeLastName;
    this.traineePostalCode = traineePostalCode;
    this.traineeCity = traineeCity;
    this.traineeBirthDate = traineeBirthDate;
    this.sexKey = sexKey;
    this.emergencyPhoneNumber = emergencyPhoneNumber;
    this.parameterValues = parameterValues;
    this.licenceValues = licenceValues;
  }
}

export class TraineeFullOffer {
  traineeKey: number;
  hasParamsToSet?: boolean;

  constructor(traineeKey: number) {
    this.traineeKey = traineeKey;
  }
}

